module.exports = __webpack_public_path__ + "static/media/groupstudy.84cf2b53.jpg";